import { NgClass, NgTemplateOutlet, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'nova-generic-dialog',
    templateUrl: './generic-dialog.component.html',
    styleUrls: ['./generic-dialog.component.scss'],
    standalone: true,
    imports: [MatIconModule, MatDialogModule, UpperCasePipe, NgTemplateOutlet, NgClass, MatLegacyButtonModule]
})
export class GenericDialogComponent {
    innerClass: string;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            cancelText: string;
            confirmText: string;
            message: string;
            title: string;
            template: any;
            panelClass: any;
            innerClass: any;
        },
        private readonly _dialogRef: MatDialogRef<GenericDialogComponent>
    ) {
        this.innerClass = data.innerClass;
    }

    cancel() {
        this.close(false);
    }

    close(value: boolean) {
        this._dialogRef.close(value);
    }

    confirm() {
        this.close(true);
    }

    @HostListener('keydown.esc')
    onEsc() {
        this.close(false);
    }
}
